module.exports = "/_next/static/images/buyers_10_en-6dcab5736bf5c6a86ea169f3cd236907.png";